import React, { useState } from 'react';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import { updatePatAlertStatus } from '../../redux/slices/scheduler/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';

function ViewAlertPopup({ alertData, patientId, close }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [notify, setNotify] = useState(
    alertData?.alertActive?.active_alert_notification === '1' ? true : false
  );
  const handleAlertNotifyCheck = async (e) => {
    e.target.checked ? setNotify(true) : setNotify(false);
    const alertNotify = e.target.checked === true ? '1' : '0';
    try {
      const response = await post(
        'api/patient/ProgressNote/updateAlertNotification',
        {
          patientId: patientId,
          alertNotify: alertNotify, //1-> if checked
          loginUserId: user?.id,
        }
      );
      if (response.status === 200) {
        setUiMessage(
          'suc',
          `Alert notification has been ${
            alertNotify === '1' ? `active` : `inactive`
          } successfully.`
        );
        dispatch(
          updatePatAlertStatus({ active_alert_notification: alertNotify })
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  return (
    <div className="modalBackground">
      <div
        className="insu-act-sec alert-main-con"
        style={{
          width: '500px',
          backgroundColor: '#fff',
          boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div
          className="main-contnr-hdr flex-sec white-bg"
          style={{
            justifyContent: 'space-between',
            borderBottom: '1px solid #dadada',
          }}
        >
          <div className="hdr-pt-info" style={{ width: 'unset' }}>
            <span className="black-txt clear-right10">Alert:</span>
          </div>
          <div
            className="book-appt-check"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <input
              type="checkbox"
              checked={notify}
              onChange={(e) => handleAlertNotifyCheck(e)}
              className="clear-right"
            />
            Active notification
          </div>
          <div className="close" onClick={close}>
            X
          </div>
        </div>
        <div className="insu-act-sec-bdy fontsize13 view-alert-bdy">
          {alertData?.getSpecificAlertData &&
            alertData?.getSpecificAlertData.map((data, i) => {
              return (
                <div
                  className={`qnsu-act-sec-bdy-lft grid-secc ${
                    i % 2 !== 0 ? 'alt-rw ' : ''
                  }`}
                  key={i}
                >
                  <div className="chrt-doc-sec-nm flex-sec">
                    {data?.alert.split('\n').map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="chrt-doc-sec-dt flex-sec sec-colr">
                    <span className="clear-right">
                      Added by: {data?.alert_added_by}
                    </span>
                    <span className="clear-right">
                      [{data?.date_added.substr(0, 10)}]
                    </span>
                    <span className="clear-right">
                      Type ({data?.alert_type === '1' ? 'Billing' : 'Clinical'})
                    </span>
                  </div>
                </div>
              );
            })}
        </div>
        <div
          className="insu-act-sec-bdy-rw white-bg"
          style={{
            padding: '9px 0px 0px',
            display: 'inline-block',
            marginBottom: '0px',
          }}
        >
          <button className="actn-No" style={{ width: '20%' }} onClick={close}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewAlertPopup;
